module.exports = __webpack_public_path__ + "static/media/Palazzo Reale - Violet - GR Green_White.f638a381.jpg";